import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useLang } from "../contexts/LanguageContext";
import { useAuth, formatApiError } from "../contexts/AuthContext";
import { QrCode, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "demo@qrmenupro.com", password: "demo12345" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-purple-50/40 to-white text-zinc-900 dark:bg-gradient-to-b dark:from-zinc-950 dark:via-purple-950/30 dark:to-zinc-950 dark:text-zinc-100 relative overflow-hidden" data-testid="login-page" style={{ marginTop: "-4rem", paddingTop: "4rem" }}>
      <div className="absolute -top-40 left-1/4 w-[500px] h-[500px] rounded-full bg-purple-600/15 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-fuchsia-600/10 blur-[120px] pointer-events-none" />
      <div className="grid lg:grid-cols-2 min-h-[calc(100vh-4rem)] relative">
        <div className="grid place-items-center p-8">
          <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="login-form">
            <div>
              <div className="w-12 h-12 rounded-2xl bg-purple-600 grid place-items-center text-white shadow-lg shadow-purple-600/40 mb-5">
                <QrCode className="h-6 w-6" />
              </div>
              <h1 className="text-3xl font-bold tracking-tight">{t("auth.loginTitle")}</h1>
              <p className="text-zinc-500 dark:text-zinc-400 mt-1 text-sm">{t("auth.loginSubtitle")}</p>
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-zinc-700 dark:text-zinc-300">{t("auth.email")}</Label>
              <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" className="rounded-xl h-11" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-zinc-700 dark:text-zinc-300">{t("auth.password")}</Label>
              <Input id="password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" className="rounded-xl h-11" />
            </div>
            <Button type="submit" disabled={busy} className="w-full rounded-2xl h-11 bg-purple-600 hover:bg-purple-700 text-white shadow-lg shadow-purple-600/30" data-testid="login-submit">
              {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {t("auth.signIn")}
            </Button>
            <div className="text-center">
              <Link to="/forgot-password" className="text-sm text-zinc-500 dark:text-zinc-400 hover:text-purple-600 dark:hover:text-purple-400" data-testid="login-forgot-link">
                {t("auth.forgot")}
              </Link>
            </div>
            <p className="text-sm text-zinc-500 dark:text-zinc-400 text-center">
              {t("auth.noAccount")}{" "}
              <Link to="/register" className="text-purple-600 dark:text-purple-400 font-semibold hover:underline" data-testid="login-to-register">
                {t("auth.signUp")}
              </Link>
            </p>
          </form>
        </div>
        <div className="hidden lg:block relative">
          <div className="absolute inset-6 rounded-3xl bg-gradient-to-br from-purple-700 via-purple-900 to-zinc-900 overflow-hidden border border-purple-500/20">
            <div className="absolute inset-0" style={{ backgroundImage: "radial-gradient(circle at 30% 20%, rgba(168,85,247,0.4), transparent 50%)" }} />
            <div className="relative h-full grid place-items-center p-12 text-white">
              <div className="max-w-sm">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/20 bg-white/5 text-xs font-medium mb-4">
                  <Sparkles className="w-3 h-3" />
                  qrmenu-pro.com
                </div>
                <p className="text-3xl font-bold leading-tight">{t("landing.heroTitle1")} <span className="text-purple-300">{t("landing.heroTitle2")}</span></p>
                <p className="mt-4 text-white/70">{t("landing.heroSubtitle")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
